import React from "react";
import { Dialog } from "primereact/dialog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSliders } from "@fortawesome/free-solid-svg-icons";

const MobileFilterSheet = ({
  visible,
  onHide,
  onApply,
  onClearAndClose,
  filterableColumns,
  buildFilterElement,
  filters,
  setFilters,
  filterCount,
  mobileFilterContent,
  simpleTable,
  t,
}) => {
  const headerContent = (
    <div className="mobile-filter-sheet__header">
      <span>{t("common.filters", "Filters")}</span>
      {filterCount > 0 && (
        <span className="mobile-filter-sheet__count">{filterCount}</span>
      )}
    </div>
  );

  const footerContent = (
    <div className="mobile-filter-sheet__footer">
      {filterCount > 0 && (
        <button
          className="mobile-filter-sheet__clear-btn"
          onClick={() => onClearAndClose?.()}
        >
          {t("common.clearAll", "Clear All")}
        </button>
      )}
      <button className="mobile-filter-sheet__apply-btn" onClick={() => onApply?.()}>
        {t("common.apply", "Apply")}
      </button>
    </div>
  );

  const hasColumnFilters = filterableColumns?.length > 0;

  if (!visible) return null;

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={headerContent}
      footer={footerContent}
      position="bottom"
      modal
      draggable={false}
      resizable={false}
      className="mobile-filter-sheet"
      style={{ width: "100vw", margin: 0 }}
      contentStyle={{ padding: 0 }}
    >
      <div className="mobile-filter-sheet__body">
        {/* Parent-injected filter content (filter statistics cards) */}
        {mobileFilterContent && (
          <div className="mobile-filter-sheet__custom-section">
            {mobileFilterContent}
          </div>
        )}

        {/* Column-level filters */}
        {hasColumnFilters && (
          <div className="mobile-filter-sheet__columns">
            {mobileFilterContent && (
              <div className="mobile-filter-sheet__section-title">
                {t("common.columnFilters", "Column Filters")}
              </div>
            )}
            <div className="mobile-filter-sheet__column-list">
              {filterableColumns.map((col) => {
                const filterEl = buildFilterElement(col);
                if (!filterEl?.filterElement) return null;

                const fieldKey = col.filterConfig?.field ?? col.field;
                const filterValue = simpleTable
                  ? filters?.[fieldKey]?.value
                  : filters?.params?.[fieldKey];
                const filterOptions = {
                  field: fieldKey,
                  value: filterValue,
                  filterApplyCallback: simpleTable
                    ? (val) => {
                        setFilters?.((prev) => ({
                          ...prev,
                          [fieldKey]: { ...prev?.[fieldKey], value: val },
                        }));
                      }
                    : () => {},
                  filterCallback: () => {},
                };

                return (
                  <div key={col.field} className="mobile-filter-sheet__field">
                    <label className="mobile-filter-sheet__label">
                      {col.header}
                    </label>
                    <div className="mobile-filter-sheet__input">
                      {filterEl.filterElement(filterOptions)}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export const MobileFilterButton = ({ filterCount, onClick }) => {
  return (
    <button className="mobile-filter-btn" onClick={onClick}>
      <FontAwesomeIcon icon={faSliders} />
      {filterCount > 0 && (
        <span className="mobile-filter-btn__badge">{filterCount}</span>
      )}
    </button>
  );
};

export default MobileFilterSheet;
